import { useFiltersMenu } from '@/composables/useFiltersMenu';

export default {
  name: 'FiltersMenu',

  emits: ['filter-change'],

  setup(props, { emit }) {
    const {
      expanded,
      selectedValueDrivers,
      selectedPortfolio,
      translatedLayers,
      filteredPortfolios,
      menuLabel,
      showSolutionsSection,
      containerHeight,
      valueDrivers,
      getTranslations,
      isActiveLayer,
      toggleMenu,
      onSelectPortfolio: baseOnSelectPortfolio,
      updateValueDrivers,
      setLayerAndRedirect,
    } = useFiltersMenu();

    const onSelectPortfolio = (portfolio) => {
      baseOnSelectPortfolio(portfolio);
      emit('filter-change');
    };

    return {
      expanded,
      selectedValueDrivers,
      selectedPortfolio,
      translatedLayers,
      filteredPortfolios,
      menuLabel,
      showSolutionsSection,
      containerHeight,
      valueDrivers,
      getTranslations,
      isActiveLayer,
      toggleMenu,
      onSelectPortfolio,
      updateValueDrivers,
      setLayerAndRedirect,
    };
  },
};